<signup-view-instructor
	[courseInvite]="courseInvite"
	(navigated)="navigate($event)"
	[infoKey]="infoKey"
	[mode]="modes.EDUCATION">
</signup-view-instructor>